import { render, staticRenderFns } from "./search-title.vue?vue&type=template&id=63ff3507"
import script from "./search-title.vue?vue&type=script&lang=js"
export * from "./search-title.vue?vue&type=script&lang=js"
import style0 from "./search-title.vue?vue&type=style&index=0&id=63ff3507&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports